// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"410":"08348981","890":"341d6f75","989":"844d6c1d"}[chunkId] + ".chunk.css";
};